import React from 'react';
import I18n from 'i18n-js';
import { core_apimessages_Money } from '../gql/graphql';

interface IProps {
  quantity: number;
  onQuantityChange: (quantity: number) => void;
  totalInStock: number;
  maxBuyerQuantity: number;
  price: core_apimessages_Money;
  onPreorder: boolean;
}

const MAX_QUANTITY_NUMBER = 10;
const QUANTITY_SELECTOR_CURRENCIES = [
  'USD',
  'EUR',
  'CAD',
  'GBP',
  'AUD',
];

export function ListingQuantitySelector(props: IProps) {
  const quantity = props.quantity || 1;
  const { onQuantityChange, totalInStock, maxBuyerQuantity, price } = props;

  function showSelector() {
    return price &&
      totalInStock > 1 &&
      price.amountCents < 10000 &&
      QUANTITY_SELECTOR_CURRENCIES.includes(price.currency);
  }

  function atMaxQuantity() {
    return quantity >= maxQuantity();
  }

  function maxQuantity() {
    return Math.min(MAX_QUANTITY_NUMBER, totalInStock, listingMaxBuyerQuantity());
  }

  function listingMaxBuyerQuantity() {
    return maxBuyerQuantity || totalInStock;
  }

  function onSubtractClick() {
    if (quantity < 1) return;

    onQuantityChange(quantity - 1);
  }

  function onAddClick() {
    if (atMaxQuantity()) return;

    onQuantityChange(quantity + 1);
  }

  function totalInStockText() {
    const count = (totalInStock > MAX_QUANTITY_NUMBER) ? '10+' : totalInStock;
    const text = props.onPreorder ? 'commons.quantitySelector.availableForPreorder' : 'commons.quantitySelector.inStock';
    return I18n.t(text, { count });
  }

  function maxBuyerQuantityText() {
    if (atMaxBuyerQuantity() && !atMaxInStock()) {
      return I18n.t('commons.quantitySelector.atMaxBuyerQuantity', { maxBuyerQuantity });
    }

    return '';
  }

  function atMaxBuyerQuantity() {
    return quantity === maxBuyerQuantity;
  }

  function atMaxInStock() {
    return quantity === totalInStock;
  }

  if (!showSelector()) {
    return null;
  }

  return (
    <div className="listing-quantity-selector">
      <button
        type="button"
        className="listing-quantity-selector__subtract"
        onClick={onSubtractClick}
        disabled={quantity === 1}
      >
        −
      </button>
      <div
        className="listing-quantity-selector__amount"
      >
        {quantity}
      </div>
      <button
        type="button"
        className="listing-quantity-selector__add"
        onClick={onAddClick}
        disabled={atMaxQuantity()}
      >
        +
      </button>
      <div className="listing-quantity-selector__stock">
        {totalInStockText() + maxBuyerQuantityText()}
      </div>
    </div >
  );
}
